import React, { useEffect, useRef } from 'react';

// AdSense ad unit component
export default function AdBanner({ style = {}, slot = "3575926907337417", format = "auto", layout = "", layoutKey = "" }) {
  const adRef = useRef();

  useEffect(() => {
    if (window.adsbygoogle && adRef.current) {
      try {
        window.adsbygoogle.push({});
      } catch (e) {
        // Ignore repeated push errors
      }
    }
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', margin: '16px 0', ...style }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', minHeight: 90 }}
        data-ad-client="ca-pub-3575926907337417"
        data-ad-slot={slot}
        data-ad-format={format}
        data-ad-layout={layout}
        data-ad-layout-key={layoutKey}
        ref={adRef}
      ></ins>
    </div>
  );
}
